import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { filter, combineLatest, map, takeUntil } from 'rxjs';

import { PhxSideBarService } from '@common/services/phx-side-bar.service';

import { BaseComponentOnDestroy } from '../../../epics/base-component-on-destroy';
import { PhxConstants } from '../../../model';

@Component({
  selector: 'app-phx-panel-messages',
  standalone: false,
  templateUrl: './phx-panel-messages.component.html',
  styleUrl: './phx-panel-messages.component.less',
  encapsulation: ViewEncapsulation.None
})
export class PhxPanelMessagesComponent extends BaseComponentOnDestroy implements OnInit {
  entityType: string;
  entityId: string;

  constructor(
    private phxSidebarService: PhxSideBarService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSidebarConfigListener();
  }

  private initSidebarConfigListener() {
    combineLatest([
      this.phxSidebarService.entityIdChange$().pipe(filter((entityId: number) => entityId != null), map(entityId => entityId.toString())),
      this.phxSidebarService.entityTypeChange$().pipe(filter((entityType: PhxConstants.SideBarEntityType) => entityType != null), map(entityType => this.getEntityType(entityType)))
    ]).pipe(
      filter(([entityId, entityType]) => entityId !== this.entityId || entityType !== this.entityType),
      takeUntil(this.isDestroyed$)
    ).subscribe(([entityId, entityType]) => {
      this.entityId = entityId;
      this.entityType = entityType;
    });
  }

  private getEntityType(entityType: PhxConstants.SideBarEntityType): string {
    switch (entityType) {
      case PhxConstants.SideBarEntityType.WorkOrder:
        return 'WorkOrder';
      case PhxConstants.SideBarEntityType.UserProfile:
        return 'Contact';
      case PhxConstants.SideBarEntityType.Organization:
        return 'Organization';
      default:
        return String(entityType);
    }
  }
}
